@if (isLocked()) {
  <div class="pin-auth-locked">
    <div class="pin-auth-locked__content">
      <h2 class="pin-auth-locked__title">
        {{ 'pin.error.too-many-attempts' | translate }}
      </h2>
      <p class="pin-auth-locked__message">
        {{ getLockMessage() }}
      </p>
    </div>
  </div>
} @else {
  <rrp-pin-pad
    #pinPad
    [titleTranslateKey]="'pin.enter-code'"
    [errorTranslateKey]="errorKey()"
    [showBiometric]="canUseBiometric()"
    [showLogout]="true"
    (pinEntered)="onPinEntered($event)"
    (biometricClick)="onBiometricClick()"
    (logoutClick)="onLogout()"
  />
}
